import React, { useEffect, useState } from "react";
import AdminSectionHeader from "@/components/admin/AdminSectionHeader";
import AdminTable from "@/components/admin/AdminTable";
import { api, formatApiError } from "@/lib/api";
import { StatusBadge } from "@/components/app/StatusBadge";
import { Users, Store, Compass, ShieldAlert } from "lucide-react";

function StatCard({ icon, label, value, hint, testId }) {
    return (
        <div data-testid={testId} className="rounded-2xl border border-md-border bg-md-surface p-5">
            <div className="flex items-center justify-between">
                <p className="md-overline">{label}</p>
                <span className="text-md-text-2">{icon}</span>
            </div>
            <p className="mt-3 text-3xl font-black tracking-tight text-md-text">{value}</p>
            {hint && <p className="mt-1 text-xs text-md-text-2">{hint}</p>}
        </div>
    );
}

export default function AdminDashboard() {
    const [summary, setSummary] = useState(null);
    const [error, setError] = useState("");
    useEffect(() => {
        api.get("/admin/dashboard/summary").then(({ data }) => setSummary(data)).catch((e) => setError(formatApiError(e)));
    }, []);
    return (
        <>
            <AdminSectionHeader
                title="Cockpit Mission Dresseur"
                description="Phase 1 — base architecture, design system, auth, paramètres globaux."
            />
            {error && <div className="mb-4 rounded-lg border border-md-danger/30 bg-md-danger/10 px-4 py-2 text-sm text-md-danger">{error}</div>}
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                <StatCard icon={<Users className="h-4 w-4" />} label="Utilisateurs" value={summary?.users_total ?? "—"} hint="Comptes publics inscrits" testId="stat-users" />
                <StatCard icon={<Compass className="h-4 w-4" />} label="Missions" value={summary?.missions_total ?? "—"} hint="Phase 3 — bientôt" testId="stat-missions" />
                <StatCard icon={<Store className="h-4 w-4" />} label="Dresseurs" value={summary?.sellers_total ?? "—"} hint={`${summary?.pending_sellers ?? 0} en attente`} testId="stat-sellers" />
                <StatCard icon={<ShieldAlert className="h-4 w-4" />} label="Litiges" value={summary?.open_disputes ?? "—"} hint="Phase 5 — bientôt" testId="stat-disputes" />
            </div>

            <div className="mt-8 rounded-2xl border border-md-border bg-md-surface p-6">
                <p className="md-overline">Doctrine — rappel</p>
                <h2 className="mt-2 text-xl font-semibold tracking-tight text-md-text">
                    Mission Dresseur n’est pas une marketplace.
                </h2>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-md-text-2">
                    Le produit organise une mission humaine de recherche. Tout doit rester générique,
                    configurable, et anti-refactor. Pricing, délais, palette, wording transactionnel —
                    tout passe par cet espace.
                </p>
            </div>
        </>
    );
}
